module.exports = __webpack_public_path__ + "static/media/rise.a722bac7.svg";